export class KeyValuePair{
	constructor(public key: any, public value: any){}
}